import { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import Img from '../ui/Img.jsx';
import Specs from './Specs.jsx';
import { FavsCtx, CmpCtx } from '../../App.jsx';

const BADGE = {
  'En pozo':       'b-pozo',
  'Apto crédito':  'b-credito',
  'Oportunidad':   'b-oportunidad',
  'Exclusiva':     'b-exclusiva',
  'A estrenar':    'b-nuevo',
  'Acepta mascotas':'b-credito',
};

function fmtPrice(p) {
  const sym = p.currency === 'USD' ? 'US$ ' : '$ ';
  const num = p.price.toLocaleString('es-AR');
  return sym + num + (p.operationType === 'alquiler' ? '/mes' : '');
}

export default function PropertyCard({ p, variant = 'grid' }) {
  const nav = useNavigate();
  const { favs, toggleFav } = useContext(FavsCtx);
  const { cmp, toggleCmp } = useContext(CmpCtx);
  const [idx, setIdx] = useState(0);
  const isFav = favs.includes(p.id);
  const inCmp = cmp.includes(p.id);
  const imgs = p.images.length ? p.images : [{ full: '', thumb: '' }];
  const cycle = (dir, e) => { e.stopPropagation(); e.preventDefault(); setIdx(i => (i + dir + imgs.length) % imgs.length); };

  return (
    <a className={"pcard pcard-" + variant} href={"/propiedad/" + p.slug}
      onClick={e => { if (e.metaKey || e.ctrlKey) return; e.preventDefault(); nav("/propiedad/" + p.slug); }}
      aria-label={p.title}>
      <div className="card-media">
        <Img src={imgs[idx].full} alt={p.title} ratio="4/3" />
        <div className="card-grad" />
        <div className="card-badges">
          {(p.tags || []).slice(0, 2).map(t => BADGE[t] && (
            <span key={t} className={"badge " + BADGE[t]}>{t}</span>
          ))}
        </div>
        <button className={"card-fav" + (isFav ? " on" : "")}
          aria-pressed={isFav} aria-label={isFav ? "Quitar de favoritos" : "Guardar"}
          onClick={e => { e.stopPropagation(); e.preventDefault(); toggleFav(p.id); }}>
          <svg width="19" height="19" viewBox="0 0 24 24" fill={isFav ? "currentColor" : "none"}
            stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M19.5 12.6 12 20l-7.5-7.4a5 5 0 0 1 7.1-7l.4.4.4-.4a5 5 0 0 1 7.1 7Z" />
          </svg>
        </button>
        {imgs.length > 1 && <>
          <button className="card-nav left" aria-label="Anterior" onClick={e => cycle(-1, e)}>‹</button>
          <button className="card-nav right" aria-label="Siguiente" onClick={e => cycle(1, e)}>›</button>
          <div className="card-dots">
            {imgs.map((_, i) => <span key={i} className={"dot" + (i === idx ? " on" : "")} />)}
          </div>
        </>}
        <span className="card-op">{p.operationType === 'alquiler' ? 'Alquiler' : 'Venta'}</span>
      </div>
      <div className="card-body">
        <div className="card-pricerow">
          <div className="card-price">
            {fmtPrice(p)}
            {p.prevPrice && <s className="card-prev">US$ {Number(p.prevPrice).toLocaleString('es-AR')}</s>}
          </div>
          {variant === 'list' && (
            <button className={"card-cmp" + (inCmp ? " on" : "")}
              onClick={e => { e.stopPropagation(); e.preventDefault(); toggleCmp(p.id); }}
              aria-pressed={inCmp} title="Comparar">⇄</button>
          )}
        </div>
        {p.expenses > 0 && <div className="card-exp">+ $ {p.expenses.toLocaleString('es-AR')} expensas</div>}
        <h3 className="card-title">{p.title}</h3>
        <div className="card-loc">📍 <span>{[{ departamento:'Dpto',casa:'Casa',ph:'PH',terreno:'Terreno',local:'Local',galpon:'Galpón',cochera:'Cochera',oficina:'Oficina' }[p.type], p.neighborhood].filter(Boolean).join(' · ')}</span></div>
        <Specs p={p} compact={variant !== 'list'} />
        {variant === 'list' && <p className="card-desc">{p.description?.slice(0, 140)}…</p>}
        {variant === 'list' && (
          <div className="card-actions">
            <span className="btn btn-primary btn-sm">Ver propiedad →</span>
            <span className="card-ref">Cód. {p.ref}</span>
          </div>
        )}
      </div>
    </a>
  );
}
